import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { trackerList } from 'lib/api/time';
import moment from 'moment';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const AppTracker = () => {
  const { t } = useTranslation();

  const [initialization, setInitialization] = useState(false);

  let initParams = {
    uri: '/report/tracker',
    sort: 'desc',
    order: 'REG_DTTM',
    pltfomTpCode: '02',
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };
  const [params, setParams] = useState(initParams);
  const [loading, setLoading] = useState(true);
  const t1 = moment(params['sDate']);
  const t2 = moment(params['eDate']);

  /**
   * 필터 초기화
   * initialization 필터 내부에서 초기화 버튼이 클릭되었을 때 기본값으로 돌려주는 함수를 실행시킴.
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
      setLoading(true);
    }
  };

  const handleTableCallBack = (state) => {
    if (!!state) {
      setLoading(false);
    }
  };

  const customized = {
    REG_DTTM: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'REG_DTTM');
        return makeRowColumn(
          rowObj['REG_DTTM'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      orderFlag: true,
    },
    SCRIPT_NAME: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'SCRIPT_NAME');
        return makeRowColumn(
          rowObj['SCRIPT_NAME'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      orderFlag: true,
    },
    ADVER_APP_NAME: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVER_APP_NAME');
        return makeRowColumn(
          rowObj['ADVER_APP_NAME'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      orderFlag: true,
    },
    ADVRTS_TP_STR: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVRTS_TP_STR');
        return makeRowColumn(
          rowObj['ADVRTS_TP_STR'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      orderFlag: true,
    },
    ADVRTS_PRDT_STR: {
      makeHead: (headsMap) => {
        return t('노출유형');
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVRTS_PRDT_STR');
        return makeRowColumn(
          rowObj['ADVRTS_PRDT_STR'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      orderFlag: true,
    },
    PRDT_NM: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'PRDT_NM');
        return makeRowColumn(
          rowObj['PRDT_NM'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      orderFlag: true,
    },
    PRDT_PRICE: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'PRDT_PRICE').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'PRDT_PRICE');
        return makeRowColumn(
          rowObj['PRDT_PRICE'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      bodyStyle: {
        textAlign: 'center',
      },
    },
    ORDER_QY: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'ORDER_QY').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ORDER_QY');
        return makeRowColumn(
          rowObj['ORDER_QY'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      bodyStyle: {
        textAlign: 'center',
      },
    },
    MOB_SESSION_ORDER_AMT: {
      makeHead: (headsMap) => {
        return (
          <InfoTitleArea
            title={getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT').label}
            tooltipTitle={t('세션매출 중 모비온 광고를 통해 발생한 매출')}
            iconType="fainfoCircle"
          />
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT');
        return makeRowColumn(
          rowObj['MOB_SESSION_ORDER_AMT'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      bodyStyle: {
        textAlign: 'center',
      },
    },
    ORDER_AMT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ORDER_AMT');
        return makeRowColumn(
          rowObj['ORDER_AMT'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      bodyStyle: {
        textAlign: 'center',
      },
    },
  };

  return (
    <>
      <NewFilterWrap loading={loading} handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDisplayFilter={false}
          useExternalFilter={false}
          pltfomTpCodeFixed={['02', '03', '04']}
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={trackerList}
        params={params}
        getParam={getParam}
        customized={customized}
        callBack={handleTableCallBack}
        useExcel={moment.duration(t2.diff(t1)).asDays() < 2}
        excelTotalRemoval
        toolTip={t(
          '트래커수집내역의 데이터가 방대하여 엑셀 다운로드 시 2일 이상의 데이터는 다운로드 되지 않습니다. 전일 또는 당일의 일일 데이터로 각각 다운받거나양일간의 데이터로만 다운로드 받아주시기 바랍니다.'
        )}
      />
    </>
  );
};

export default withRouter(AppTracker);
